import * as React from 'react';
import { Button, message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	getAllInvoiceDocumentsForSupplier,
	getInvoiceCheckInImagesForSupplier,
	getInvoiceCheckOutImagesForSupplier,
	invoicesRestCrudThunksForSupplier,
	sendInvoiceByEmailForSupplier,
} from '../../thunks/invoices_thunks';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Link } from 'react-router-dom';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import { INVOICES_CRUD_ACTION_CREATORS } from '../../actions/invoices_actions';
import { updatePaginationInvoices } from '../../thunks/invoices_thunks_wrapper';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import InvoiceEditButton from '../invoice_edit_button/InvoiceEditButton';
import {
	getInvoiceSubUrl,
	getInvoiceRestCrudThunksFromPath,
	isClientInvoiceViewLocation,
} from '../invoice_utilities/InvoiceUtilities';
import { getWorkOrderPath } from '../../utils/WorkOrderUtils';

const queryString = require('qs');
require('./SupplierInvoicesDetailPage.less');

interface InvoicesDetailPageState {}

class SupplierInvoicesDetailPage extends React.Component<any, InvoicesDetailPageState> {
	state = {
		sendInvoiceByEmailModalVisible: false,
		documentsReceived: false,
		checkInImagesReceived: false,
		checkOutImagesReceived: false,
		documents: [],
		checkInImages: [],
		checkOutImages: [],
		loading: true,
		backLinkTo: 'supplier/invoices',
		backLinkText: 'Back to invoices',
		basePath: 'supplier/invoices',
		fromTargetCollectionName: null,
	};

	constructor(props) {
		super(props);
	}

	formRefs = {
		sendInvoiceByEmailForm: null,
	};

	componentDidMount() {
		const { getInvoice, invoice, match, getInvoiceDelta, history } = this.props;
		const invoiceId = match.params.id;
		if (invoice && invoice.id) {
			this.initialize(invoice);
			if (isClientInvoiceViewLocation(history.location)) {
				getInvoiceDelta(invoice.id);
			}
		} else {
			getInvoice(invoiceId).then((invoice) => {
				this.initialize(invoice);
			});
		}

		/*
		getAllDocuments(invoiceId).then((documents) => {
			this.setState({ documents: documents, documentsReceived: true });
		});

		getCheckInImages(invoiceId).then((checkInImages) => {
			this.setState({ checkInImages: checkInImages, checkInImagesReceived: true });
		});

		getCheckOutImages(invoiceId).then((checkOutImages) => {
			this.setState({ checkOutImages: checkOutImages, checkOutImagesReceived: true });
		});
		*/
	}

	initialize = (invoice) => {
		const { location, userType, currentUser } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({ fromTargetCollectionName: queryParams.targetCollectionName });
		}
		const basePath = getInvoiceSubUrl(userType, currentUser, invoice);
		if (queryParams.backlinkParams) {
			const { pathName, backLinkText, ...otherParams } = queryString.parse(
				queryParams.backlinkParams
			);
			const finalPath = pathName || `/${basePath}/overview/all`;
			this.setState({
				loading: false,
				basePath: basePath,
				backLinkTo: `${finalPath}?${new URLSearchParams(otherParams).toString()}`,
				...(backLinkText && { backLinkText }),
			});
		} else {
			this.setState({
				loading: false,
				basePath: basePath,
				backLinkTo: `/supplier/invoices/overview/all`,
			});
		}
	};

	componentDidUpdate(prevProps) {
		const {
			invoice,
			getInvoiceDelta,
			getAllDocuments,
			getCheckInImages,
			getCheckOutImages,
			history,
		} = this.props;
		const { invoice: prevInvoice } = prevProps;
		if (invoice && prevInvoice && invoice.id !== prevInvoice.id) {
			if (isClientInvoiceViewLocation(history.location)) {
				getInvoiceDelta(invoice.id);
			}
			/*
			getAllDocuments(invoice.id).then((documents) => {
				this.setState({ documents: documents, documentsReceived: true });
			});

			getCheckInImages(invoice.id).then((checkInImages) => {
				this.setState({ checkInImages: checkInImages, checkInImagesReceived: true });
			});

			getCheckOutImages(invoice.id).then((checkOutImages) => {
				this.setState({ checkOutImages: checkOutImages, checkOutImagesReceived: true });
			});
			*/
		}
	}

	handleSendByEmailSubmit = () => {
		const { sendInvoiceByEmail } = this.props;
		const form = this.formRefs['sendInvoiceByEmailForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const checkInImagesString =
				values.checkInImages && values.checkInImages.length > 0
					? values.checkInImages.map((p) => {
							const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
							const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
							return `${fileId}/${fileName}`;
					  })
					: [];
			const checkOutImagesString =
				values.checkOutImages && values.checkOutImages.length > 0
					? values.checkOutImages.map((p) => {
							const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
							const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
							return `${fileId}/${fileName}`;
					  })
					: [];
			const data = {
				checkInImages: checkInImagesString,
				checkOutImages: checkOutImagesString,
				documents: values.documents,
			};
			sendInvoiceByEmail(values.invoiceId, values.email, data).then(() => {
				this.setState({
					sendInvoiceByEmailModalVisible: false,
				});
				message.success(`Invoice sent to ${values.email}.`);
			});
		});
	};

	handleSendByEmailCancel = (e) => {
		this.setState({
			sendInvoiceByEmailModalVisible: false,
		});
	};

	handleTabChange = (key) => {
		const { history, match } = this.props;
		const { basePath } = this.state;
		const invoiceId = match.params.id;
		history.push(`/${basePath}/detail/${invoiceId}/${key}`);
	};

	handleDelete = () => {
		const { history, deleteInvoice, invoice } = this.props;
		const { basePath } = this.state;
		deleteInvoice(invoice).then(() => {
			history.push(`/${basePath}/overview/all`);
		});
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleSendByEmail = () => {
		this.setState({
			sendInvoiceByEmailModalVisible: true,
		});
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	editInvoice = () => {
		const { match, history } = this.props;
		const invoiceId = match.params.id;
		history.push(`/supplier/invoices/edit/${invoiceId}`);
	};

	viewWorkOrder = () => {
		const { invoice, history } = this.props;
		history.push(`/supplier/workOrders/detail/${nullSafeGet('workOrder.id', invoice)}/details`);
	};

	render() {
		const {
			invoice,
			match,
			companyConfig,
			currentUser,
			invoices,
			location,
			history,
			updatePagination,
			cloneTargetCollection,
			userType,
		} = this.props;
		const { basePath } = this.state;
		const invoiceId = match.params.id;
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			...(invoice && invoice.revisionChanges
				? [
						{
							key: 'revisions',
							name: 'Revisions',
						},
				  ]
				: []),
		];

		const invoiceActions = [
			<Link
				target={'_'}
				to={`/supplier/workOrders/detail/${nullSafeGet('workOrder.id', invoice)}/${getWorkOrderPath(
					userType,
					currentUser,
					invoice
				)}details`}
			>
				<Button ghost={true}>
					View Work Order <i className="icons8-font icons8-external-link ml-2" />
				</Button>
			</Link>,
			<Link
				className="ml-3"
				target={'_'}
				to={`/supplier/workOrders/detail/${nullSafeGet('workOrder.id', invoice)}/${getWorkOrderPath(
					userType,
					currentUser,
					invoice
				)}notes`}
			>
				<Button ghost={true}>
					View Notes <i className="icons8-font icons8-external-link ml-2" />
				</Button>
			</Link>,
			<InvoiceEditButton invoice={invoice} ghost={true} />,
		];
		return (
			<div className="invoicesDetailPage">
				{/*this.state.documentsReceived &&
				this.state.checkInImagesReceived &&
				this.state.checkOutImagesReceived ? (
					<SupplierSendInvoiceByEmailForm
						wrappedComponentRef={this.saveFormRef('sendInvoiceByEmailForm')}
						visible={this.state.sendInvoiceByEmailModalVisible}
						onCancel={this.handleSendByEmailCancel}
						onSubmit={this.handleSendByEmailSubmit}
						invoiceId={invoiceId}
						documents={this.state.documents}
						checkInImages={this.state.checkInImages}
						checkOutImages={this.state.checkOutImages}
					/>
				) : null*/}

				<DetailPageHeader
					exactPath={`/${basePath}/detail/:id`}
					redirectPath={`/${basePath}/detail/${invoiceId}/details`}
					backLinkText={this.state.backLinkText}
					backLinkTo={this.state.backLinkTo}
					title={nullSafeGet('workOrder.title', invoice)}
					subtitle={
						nullSafeGet('workOrder.location.name', invoice) ? (
							<div className="body1">{nullSafeGet('workOrder.location.name', invoice)}</div>
						) : null
					}
					actions={
						<div className="flex flex-row flex-wrap justify-end gap-y-4">{invoiceActions}</div>
					}
					tabs={tabs}
					handleTabChange={this.handleTabChange}
					checkTabActive={this.checkTabActive}
					backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
					childRoutes={this.props.childRoutes}
					tabsRightActions={() => (
						<NextPreviousButton
							key={this.state.fromTargetCollectionName}
							location={location}
							history={history}
							activeId={invoice.id}
							getEnitityUrl={(id) => `/${basePath}/detail/${id}/details`}
							stateSlice={invoices}
							targetCollectionName={this.state.fromTargetCollectionName}
							updatePagination={updatePagination}
							cloneTargetCollection={cloneTargetCollection}
							entityName="invoice"
						/>
					)}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	invoicesFetching: state.invoices.fetching,
	invoice: getEntityById(ownProps.match.params.id, state.invoices),
	invoices: state.invoices,
	match: ownProps.match,
	history: ownProps.history,
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getInvoice: (id) =>
		dispatch(
			getInvoiceRestCrudThunksFromPath(ownProps.userType, ownProps.history.location).readOne(id)
		),
	getInvoiceDelta: (id) =>
		dispatch(
			getInvoiceRestCrudThunksFromPath(ownProps.userType, ownProps.history.location).readDelta(id)
		),
	sendInvoiceByEmail: (id, email, data) => dispatch(sendInvoiceByEmailForSupplier(id, email, data)),
	deleteInvoice: (entity) =>
		dispatch(invoicesRestCrudThunksForSupplier.delete(entity, 'id', null, true)),
	getAllDocuments: (id) => dispatch(getAllInvoiceDocumentsForSupplier(id)),
	getCheckInImages: (id) => dispatch(getInvoiceCheckInImagesForSupplier(id)),
	getCheckOutImages: (id) => dispatch(getInvoiceCheckOutImagesForSupplier(id)),
	cloneTargetCollection: (from, to) =>
		dispatch(INVOICES_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationInvoices('supplier')(
				false,
				ownProps.history,
				targetCollectionName,
				pagination,
				true
			)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierInvoicesDetailPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
